// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"Popover_popoverContent__51lRP","slideUp":"Popover_slideUp__HfRH7","slideDown":"Popover_slideDown__IcysY"};